import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=d8b053ac&scoped=true"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b053ac",
  null
  
)

export default component.exports